import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '', type = 'website', image, jsonLd }) => {
  const siteUrl = 'https://sdorawellbeing.org';
  const fullUrl = `${siteUrl}${path}`;
  const siteName = 'SDORA Wellbeing LLC';
  const defaultDesc = 'Compassionate outpatient mental health therapy, psychiatric rehabilitation (PRP), medication management, and case management in Pikesville & Baltimore County, MD. CARF accredited. Accepting Medicaid.';
  const defaultImage = 'https://customer-assets.emergentagent.com/job_wellness-upgrade-1/artifacts/sthkmul7_SDORA_Logo-copy.png';
  const desc = description || defaultDesc;
  const ogImage = image || defaultImage;
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Mental Health Services | Pikesville, MD`;

  // Auto-generate BreadcrumbList from path
  const breadcrumb = path ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl },
      ...(path.split('/').filter(Boolean).map((seg, i, arr) => ({
        "@type": "ListItem",
        "position": i + 2,
        "name": seg.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
        "item": `${siteUrl}/${arr.slice(0, i + 1).join('/')}`
      })))
    ]
  } : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {breadcrumb && (
        <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      )}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
